import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { getCandidateAssessments } from './queries';

export const candidateAssessmentsApi = createApi({
  reducerPath: ReducerPaths.CANDIDATE_ASSESSMENTS,
  baseQuery,
  tagTypes: ['CandidateAssessments'],
  endpoints: (builder) => ({
    getCandidateAssessments: getCandidateAssessments(builder),
  }),
});

export const {
  useGetCandidateAssessmentsQuery,
  useLazyGetCandidateAssessmentsQuery,
} = candidateAssessmentsApi;
